import { useParams } from "react-router-dom";
// import { CompanySingle } from "../../../features/Company/CompanySingle";
import { CompanySingle2 } from "../../../features/Company/CompanySingle2";

export function CompanySinglePage() {
  const { uuid } = useParams();
  return (
    <div>
      {/* <Dummy uuid={uuid} /> */}
      <CompanySingle2 uuid={uuid} />
    </div>
  );
}
